import { MODULE_NAME } from './const';
import { rootNodeOfRouteSelection, nodesInSelectedRoute, lastNodeOfRouteSelection } from './getters';
import {
	SET_IS_CONVERTING_TO_SUBFLOW,
	SET_ROOT_NODE_OF_ROUTE_SELECTION,
	SET_IS_ROUTE_SELECTED,
	SET_LAST_NODE_OF_ROUTE_SELECTION,
	SET_WORKFLOW_GRAPHS,
} from './mutations';
import state, { initialState } from './state';
import StoreModuleService from '../StoreModuleService';
import { getAction } from '@/store/modules/actions/getters';
import { convertToSubflow } from '@/store/modules/selectedWorkflow/actions';
import * as WorkflowGraphService from '@/utils/workflow/workflow-graph-service';

const buildWorkflowGraphsActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setIsSelectingWorkflowRoute = buildWorkflowGraphsActionObject('setIsSelectingWorkflowRoute');
export const setIsRouteSelected = buildWorkflowGraphsActionObject('setIsRouteSelected');
export const setRootNodeOfRouteSelection = buildWorkflowGraphsActionObject('setRootNodeOfRouteSelection');
export const setLastNodeOfRouteSelection = buildWorkflowGraphsActionObject('setLastNodeOfRouteSelection');
export const setWorkflowGraphs = buildWorkflowGraphsActionObject('setWorkflowGraphs');
export const resetWorkflowGraphs = buildWorkflowGraphsActionObject('resetWorkflowGraphs');
export const convertGraphToSubflow = buildWorkflowGraphsActionObject('convertGraphToSubflow');

const actions = {
	...StoreModuleService.createDefaultActions(),

	[setIsSelectingWorkflowRoute.action]({ dispatch, commit }, isConverting) {
		if (!isConverting) {
			dispatch(setRootNodeOfRouteSelection.action, initialState.rootNodeOfRouteSelection);
			dispatch(setLastNodeOfRouteSelection.action, initialState.lastNodeOfRouteSelection);
		}
		commit(SET_IS_CONVERTING_TO_SUBFLOW, isConverting);
	},
	[setIsRouteSelected.action]({ commit }, payload) {
		commit(SET_IS_ROUTE_SELECTED, payload);
	},
	[setRootNodeOfRouteSelection.action]({ commit }, payload) {
		commit(SET_ROOT_NODE_OF_ROUTE_SELECTION, payload);
	},
	[setLastNodeOfRouteSelection.action]({ commit }, payload) {
		commit(SET_LAST_NODE_OF_ROUTE_SELECTION, payload);
	},
	[setWorkflowGraphs.action]({ commit, rootGetters }, { nodes, edges }) {
		const actionGetter = rootGetters[getAction.fullPath];
		console.log({ nodes, edges, actionGetter });
		const dag = WorkflowGraphService.createWorkflowGraph(nodes, edges, actionGetter);
		commit(SET_WORKFLOW_GRAPHS, { dag });
	},
	[resetWorkflowGraphs.action]({ commit }) {
		WorkflowGraphService.destroy(state.workflowGraphs);
		commit(SET_WORKFLOW_GRAPHS, null);
	},
	async [convertGraphToSubflow.action]({ dispatch, getters }, { subflowName }) {
		const selectedRoute = getters[nodesInSelectedRoute.getter];
		let startNodeId = selectedRoute[0];
		let endNodeId = getters[lastNodeOfRouteSelection.getter];
		if (selectedRoute.length === 0) {
			startNodeId = getters[rootNodeOfRouteSelection.getter];
			endNodeId = startNodeId;
		}
		const result = await dispatch(
			convertToSubflow.fullPath,
			{ startNodeId: Number(startNodeId), endNodeId: Number(endNodeId), subflowName },
			{ root: true }
		);
		await Promise.all([dispatch(setIsSelectingWorkflowRoute.action, false), dispatch(resetWorkflowGraphs.action)]);
		return result;
	},
};

export default actions;
